<template>
  <div
    style="color: black; z-index: 1;  top: 0; left: 0; right: 0; bottom: 0 "
    :style="{'position': inline == true ? 'initial' : 'absolute', 'background-color' : backgroundColor}"
  >
    <v-layout fill-height column justify-center>
      <div
        class="text-xs-center mt-4"
        style="margin-bottom: 25px;"
        :style="{'margin-top': marginTop + 'px' }"
      >
        <img
          v-if="showAll"
          src="/static/img/assets/setting/premium_alert.png"
          alt
          style="width: 100%; max-width: 300px"
        />
        <h3
          style="text-shadow: 1px 1px 20px #9e9e9e;"
          v-if="size == 'big'"
          class="display-1"
        >{{$t('Its time to upgrade.')}}</h3>
        <h3
          style="text-shadow: rgb(255, 105, 105) 1px 1px 20px;"
          v-else
          class="headline"
        >{{$t('Its time to upgrade.')}}</h3>
        <template v-if="selectedBot.pagetype != 'enterprise'">
          <p
            style="text-shadow: rgb(80, 80, 80) 1px 1px 20px;"
          >{{$t('Upgrade Your Plan to use PREMIUM features , only 500 THB/month')}}</p>

          <v-btn
            depressed
            style="margin-bottom:1.5em"
            :to="'/'+$i18n.locale()+'/upgrade'"
            small
            color="primary"
          >{{$t('Upgrade to Premium Plan')}}</v-btn>
        </template>
      </div>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    showAll: {
      default: true
    },
    inline: {
      default: false
    },
    marginTop: {
      default: 0
    },
    backgroundColor: {
      default: '#ecececbd'
    },
    size: {
      default: 'big'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/elements/PremiumPlanPopup.vue